import request from 'superagent';
import { Query } from 'acast-reactor';
import { Episode } from 'resources';
import { updateEntity } from 'app/entity';
import { trackOperation } from 'app/operations';
import store from 'app/store';
import Config from 'app/config';
import { getUserToken } from 'services/authentication';
import { moveEpisodeToDrafts } from 'resources/show';
import PublishHistory from 'resources/episode-publish-history';

function runUnpublishAPICall(episode) {
  return new Promise((resolve, reject) => {
    const API_HOST = Config.get('CREATE_API_HOST');

    request
      .post(`${API_HOST}/api-v2/acasts/${episode.id}/unpublish`)
      .set('Authorization', `Bearer ${getUserToken()}`)
      .send(episode)
      .end(err => {
        if (err) {
          return reject(err);
        }
        // TODO: The res.body here should be the published episode so that
        //       we can re-inject it into our store. Otherwise we have to
        //       do what we do now which is to make an extra call to load it.
        return resolve(episode);
      });
  });
}

function readBackEpisodeAfterPublish(episode) {
  return new Promise((resolve, reject) => {
    Query.run('episode/read', episode.id)
      .then(result => resolve(result.value))
      .catch(error => reject(error));
  });
}

function updateLocalEntityFromResult(result) {
  return store.dispatch(Episode.Actions.update(result.id, result));
}

function removeAcastPlusConditions(episode) {
  return updateEntity(
    Episode,
    episode.merge({
      conditions: [],
    })
  );
}

function reloadPublishHistory(episode) {
  return store.dispatch(PublishHistory.read(episode.id, true)).then(() => episode);
}

function runUnpublishEpisode(episode) {
  return runUnpublishAPICall(episode)
    .then(readBackEpisodeAfterPublish)
    .then(reloadPublishHistory)
    .then(updateLocalEntityFromResult)
    .then(removeAcastPlusConditions)
    .then(() => moveEpisodeToDrafts(episode));
}

export default episode => {
  const operation = runUnpublishEpisode(episode);
  const id = `${episode.id}/publish`;

  return store.dispatch(trackOperation(operation, id)).catch(error => {
    // eslint-disable-next-line
    console.log('Unable to unpublish episode', error);
    throw error;
  });
};
